import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { DataContext } from '../Provider/dataProvider';
import { fetchWithAuth } from '../utils/authUtils';
import '../css/myRelative.css';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

const MedicationChecklistSelect = () => {
    const { data } = useContext(DataContext);
    const navigate = useNavigate();
    const [elderlies, setElderlies] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        loadElderlies();
    }, []);

    const loadElderlies = async () => {
        try {
            const response = await fetchWithAuth(`${API_BASE}/relatives`);
            const payload = await response.json().catch(() => ({}));
            if (response.ok && payload?.success) {
                setElderlies(Array.isArray(payload?.data) ? payload.data : []);
            } else {
                setError(payload?.message || 'Không thể tải danh sách người cao tuổi.');
            }
        } catch (err) {
            setError(err?.message || 'Không thể tải danh sách người cao tuổi.');
        } finally {
            setLoading(false);
        }
    };

    const getInitial = (fullName) => {
        if (!fullName || fullName.trim() === '') return 'N';
        return fullName.trim().substring(0, 1).toUpperCase();
    };

    if (loading) {
        return (
            <main className="tamcare-main-content-relatives">
                <div className="tamcare-page-header">
                    <h1>Lịch uống thuốc</h1>
                    <p>Đang tải danh sách người cao tuổi...</p>
                </div>
            </main>
        );
    }

    if (error) {
        return (
            <main className="tamcare-main-content-relatives">
                <div className="tamcare-page-header">
                    <h1>Lịch uống thuốc</h1>
                    <p>{error}</p>
                </div>
            </main>
        );
    }

    return (
        <main className="tamcare-main-content-relatives">
            <div className="tamcare-page-header">
                <h1>Lịch uống thuốc</h1>
                <p>Chọn người cao tuổi để xem lịch nhắc uống thuốc</p>
            </div>

            <div className="tamcare-relative-grid">
                {elderlies && elderlies.length > 0 ? (
                    elderlies.map((elderly) => (
                        <div key={elderly.id} className="tamcare-relative-card">
                            <div className="tamcare-relative-header">
                                <div className="tamcare-initial-avatar" style={{ overflow: 'hidden' }}>
                                    {elderly?.avatar ? (
                                        <img src={`${API_BASE}${elderly.avatar}`} alt="avatar" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '18px' }} />
                                    ) : (
                                        getInitial(elderly.fullName)
                                    )}
                                </div>
                                <div className="tamcare-relative-info">
                                    <h3>{elderly.fullName || 'Không xác định'}</h3>
                                    <p>Mã kết nối: {elderly.linkKey || elderly.id}</p>
                                </div>
                            </div>

                            <div className="tamcare-relative-body">
                                <div className="tamcare-checkin-status">
                                    <span>Liên kết từ:</span>
                                    <span className="tamcare-status-badge done">
                                        <i className="fa-solid fa-link"></i>
                                        {elderly.linkedAt ? new Date(elderly.linkedAt).toLocaleDateString('vi-VN') : 'Đã liên kết'}
                                    </span>
                                </div>

                                <div className="tamcare-relative-actions">
                                    <button
                                        className="tamcare-btn-detail"
                                        type="button"
                                        onClick={() => navigate(`/medication-checklist/${elderly.id}`)}
                                    >
                                        <i className="fa-solid fa-pills"></i>
                                        Xem lịch uống thuốc
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="tamcare-empty-state">
                        <i className="fa-solid fa-users-slash"></i>
                        <p>Chưa có người cao tuổi nào được liên kết. Vui lòng liên kết để xem lịch uống thuốc.</p>
                    </div>
                )}
            </div>
        </main>
    );
};

export default MedicationChecklistSelect;
